import React from 'react';
const RelatedLinks = () => {
  const relatedLinks = [
    {
      title: 'احسب عمرك',
      url: '/calculator/ar/agegregorian/',
    },
    {
      title: 'عدد التسبيح والإستغفار',
      url: '/calculator/ar/tally-counter/',
    },
    {
      title: 'احسب اذا كان وزنك مناسب لطولك',
      url: '/calculator/ar/bmiadults/',
    },
    {
      title: 'حاسبة الدورة الشهرية',
      url: '/calculator/ar/period/',
    },
    {
      title: 'احسب إذا تجب عليك الزكاة',
      url: '/calculator/ar/money-zakat/',
    },
    {
      title: 'حساب وتحويل معدلك الجامعي',
      url: '/calculator/ar/gpagrade/',
    },
  ];
  return (
    <div style={{ margin: '20px 0' }}>
      <b style={{
        display: 'block',
        marginBottom: '15px',
        fontSize: '16px',
        color: '#1a5f3f',
        fontFamily: 'Tajawal, sans-serif'
      }}>
        حواسب قد تهمك:
      </b>
      <div className="related-links-container" style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px'
      }}>
        {relatedLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary btn-sm"
            style={{
              marginBottom: '8px'
            }}
          >
            {link.title}
          </a>
        ))}
      </div>
    </div>
  );
};
export default RelatedLinks;